// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { PhoneInput } from "react-international-phone";

//imports components
import { userLogged } from "../userLogged";
import { logoutUser } from "../logoutUser";
import { urlAPI_Current } from "../config";


export function UserEditProfile({darkMode, onUpdate }) {
  const [userData, setUserData] = useState({
    nome: '',
    email: '',
    celular: '',
  });
  
  const [isEditing, setIsEditing] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  const navigateTo = useNavigate()

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  async function handleUpdatePassword() {
    if (newPassword !== confirmPassword) {
      toast.error("As senhas não iguais");
      return;
    }

    console.log("Senha atual:", currentPassword);
    console.log("Nova senha:", newPassword);

    try{
      const responseProfile = await axios.post(`${urlAPI_Current}/updatePassword`,{
          password: currentPassword,
          newPassword: newPassword,
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
      });
      
      if(responseProfile.data.success){
        toast.success("Senha trocada com sucesso!");
      } else {
        toast.success("Erro! Senha atual não coincide");
      }
    }catch(err){
        console.log(err)
    } finally {
      setIsEditing(false);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  async function getUserLogged(){
    const user = await userLogged();
    setUserData(user)

    if (!user) {
      toast.error('Faça o login primeiro');
      navigateTo('/login');
    } 
  }

  async function cancelChanges(){
    getUserLogged();
  }

  async function saveChangesInfo(){
    try{
      if(selectedFile){
        console.log(selectedFile);
        const formData = new FormData();
        formData.append(`userPhoto`, selectedFile);
        formData.append('userId', userData.codUsuario);
        formData.append('idPhoto', userData.foto);

        const responsePhoto = await axios.post(`${urlAPI_Current}/updateUserPhoto`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if(responsePhoto.data.success == false){
          toast.error("Erro ao atualizar foto!");
        }
      }
        const responseProfile = await axios.post(`${urlAPI_Current}/updateUserData`,{
          name: userData.nome,
          email: userData.email,
          phone: userData.celular
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        });
        
        if(responseProfile.data.success){
          onUpdate();
          toast.success("Dados atualizados com sucesso!");
        } else {
          toast.error("Erro ao atualizar dados!");
        }
    }catch(err){
        console.log(err)
    }
  }

  useEffect(() => {
    getUserLogged();
  }, []);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  return (
    <div>
      <div
        className="card mb-5 mb-xl-10"
        data-bs-theme={darkMode ? "dark" : "light"}
      >
        <div
          className="card-header border-0 cursor-pointer"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#kt_account_profile_details"
          aria-expanded="true"
          aria-controls="kt_account_profile_details"
        >
          <div className="card-title m-0">
            <h3 className="fw-bold m-0">Profile Details</h3>
          </div>
        </div>

        <div id="kt_account_settings_profile_details" className="collapse show">
          <form className="form">
            <div className="card-body border-top p-9">
            <div className="row mb-6">
            <label className="col-lg-4 col-form-label required fw-semibold fs-6">
              Foto
            </label>
            <div className="col-lg-8 fv-row">
              <input
                type="file"
                name="photo"
                className="form-control form-control-lg form-control-solid"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>
          </div>

              <div className="row mb-6">
                <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                  Nome
                </label>

                <div className="col-lg-8 fv-row">
                  <input
                    type="text"
                    name="name"
                    className="form-control form-control-lg form-control-solid"
                    placeholder="Nome completo"
                    value={userData.nome}
                    onChange={(e) => setUserData({ ...userData, nome: e.target.value })}
                  />
                </div>
              </div>

              <div className="row mb-6">
                <label className="col-lg-4 col-form-label required fw-semibold fs-6">
                  Email
                </label>

                <div className="col-lg-8 fv-row">
                  <input
                    type="text"
                    name="email"
                    className="form-control form-control-lg form-control-solid"
                    placeholder="Email"
                    value={userData.email}
                    onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                  />
                </div>
              </div>

              <div className="row mb-6">
                <label className="col-lg-4 col-form-label fw-semibold fs-6">
                  <span className="required">Celular</span>
                </label>

                <div className="col-lg-8 fv-row">
                  <PhoneInput  defaultCountry="br" value={userData.celular} className="form-control form-control-lg form-control-solid"
                      onChange={(value) => setUserData({ ...userData, celular: value })}
                  />
                </div>
              </div>
            </div>

            <div className="card-footer d-flex justify-content-end py-6 px-9">
              <button
                type="reset"
                className="btn btn-light btn-active-light-primary me-2"
                onClick={cancelChanges}
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                onClick={saveChangesInfo}
                type="button"
              >
                Alterar
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        className="card mb-5 mb-xl-10"
        data-bs-theme={darkMode ? "dark" : "light"}
      >
        <div
          className="card-header border-0 cursor-pointer"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#kt_account_signin_method"
        >
          <div className="card-title m-0">
            <h3 className="fw-bold m-0">Segurança</h3>
          </div>
        </div>

        <div className="card mb-5 mb-xl-10">
          <div id="kt_account_settings_signin_method" className="collapse show">
            <div className="card-body border-top p-9">
              <div className="d-flex flex-wrap align-items-center mb-10">
                {!isEditing ? (
                  <div id="kt_signin_password">
                    <div className="fs-6 fw-bold mb-1">Senha</div>
                    <div className="fw-semibold text-gray-600">
                      ************
                    </div>
                  </div>
                ) : (
                  <div id="kt_signin_password_edit" className="flex-row-fluid">
                    <form
                      id="kt_signin_change_password"
                      className="form"
                      noValidate
                    >
                      <div className="row mb-1">
                        <div className="col-lg-4">
                          <div className="fv-row mb-0">
                            <label
                              htmlFor="currentpassword"
                              className="form-label fs-6 fw-bold mb-3"
                            >
                              Senha Atual
                            </label>
                            <input
                              type="password"
                              className="form-control form-control-lg form-control-solid"
                              name="currentpassword"
                              id="currentpassword"
                              value={currentPassword}
                              onChange={(e) =>
                                setCurrentPassword(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="fv-row mb-0">
                            <label
                              htmlFor="newpassword"
                              className="form-label fs-6 fw-bold mb-3"
                            >
                              Nova Senha
                            </label>
                            <input
                              type="password"
                              className="form-control form-control-lg form-control-solid"
                              name="newpassword"
                              id="newpassword"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="fv-row mb-0">
                            <label
                              htmlFor="confirmpassword"
                              className="form-label fs-6 fw-bold mb-3"
                            >
                              Confirmar Nova Senha
                            </label>
                            <input
                              type="password"
                              className="form-control form-control-lg form-control-solid"
                              name="confirmpassword"
                              id="confirmpassword"
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-text mb-5">
                        A senha tem que possuir pelo menos 8 caracteres
                      </div>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn btn-primary me-2 px-6"
                          onClick={handleUpdatePassword}
                        >
                          Atualizar Senha
                        </button>
                        <button
                          type="button"
                          className="btn btn-color-gray-500 btn-active-light-primary px-6"
                          onClick={handleCancelClick}
                        >
                          Cancelar
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {!isEditing && (
                  <div id="kt_signin_password_button" className="ms-auto">
                    <button
                      className="btn btn-light btn-active-light-primary"
                      onClick={handleEditClick}
                    >
                      Redefinir Senha
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
